<template>
  <div class="page flex-col">
    <StudentHeader :title="title" />

    <div class="main_container flex-col">
      <div class="content_section flex-col">
        <div class="header_section flex-row">
          <span class="course_title">{{ info.courseName }}</span>
          <span class="completion_text"
            >完成度（{{ info.complete }}/{{ info.taskCount }}）</span
          >
          <div class="progress_bar_container">
            <div
              :style="{ width: info.progress }"
              class="progress-fill"
            ></div>
          </div>
          <span class="progress_text">{{ info.progress }}</span>
        </div>
        <div class="task_section flex-col">
          <div class="task_filter_group flex-row justify-between">
            <div
              class="normal_task_button flex-row"
              @click="resetList(0)"
              :class="{ selected: selectedType === 0 }"
            >
              <img
                class="task_icon"
                referrerpolicy="no-referrer"
                src="../../assets/student/course/FigmaDDSSlicePNG46ccee803fb179e50e3230f742fd1d0d.png"
              />
              <span
                class="task_label"
                :class="{ text_selected: selectedType === 0 }"
              >
                任务({{ info.tasknum }})
              </span>
            </div>
            <div
              class="challenge_task_button flex-row"
              @click="resetList(1)"
              :class="{ selected: selectedType === 1 }"
              v-if="info.hardnum > 0"
            >
              <img
                class="challenge_icon"
                referrerpolicy="no-referrer"
                src="../../assets/student/course/FigmaDDSSlicePNG09e55b9323cf3b4ebc9b841b1e111c38.png"
              />
              <span
                class="challenge_label"
                :class="{ text_selected: selectedType === 1 }"
              >
                挑战任务({{ info.hardnum }})
              </span>
            </div>
          </div>
          <div 
            class="task_list_container flex-row justify-between" 
            ref="taskListContainer"
            @mousedown="handleMouseDown"
            @touchstart="handleTouchStart"
          >
            <div
              class="task_card user_select_none flex-col"
              v-for="item in lists"
              @click="handleTaskClick(item, $event)"
            >
              <div class="task_header flex-row justify-between">
                <span class="task_serial">{{ item.taskSerialNo }}：</span>
                <img
                  class="completion_icon"
                  referrerpolicy="no-referrer"
                  v-if="item.completedStatu === 1"
                  src="../../assets/student/course/FigmaDDSSlicePNGdabb3e0b4f6ac0a09cc34564ff9d3972.png"
                />
              </div>
              <img
                class="task_image"
                draggable="false"
                referrerpolicy="no-referrer"
                :src="item.taskImageUrl"
                style="user-select: none"
              />
              <span
                class="task_name"
                style="user-select: none"
                >{{ item.taskName }}</span
              >
            </div>
          </div>
          <div
            class="pagination_container user_select_none flex-row justify-center w-full"
          >
            <img
              v-for="i in Math.ceil(lists.length / 3)"
              :key="i"
              class="pagination_dot"
              referrerpolicy="no-referrer"
              src="../../assets/student/course/FigmaDDSSlicePNGd8cd63451bc4b71dde00b01a3f442fdf.png"
            />
          </div>
        </div>
        <div class="learning_target_header flex-row">
          <div class="target_title_group flex-row justify-between">
            <img
              class="target_icon"
              referrerpolicy="no-referrer"
              src="../../assets/student/course/FigmaDDSSlicePNG91088fc7b901a65de90d00313b1d1d22.png"
            />
            <span class="target_title">学习目标</span>
          </div>
        </div>
        <div class="learning_content flex-row justify-between">
          <span class="target_list">
            <li v-for="target in targets">
              {{ target }}
            </li>
          </span>
          <div class="resource_section flex-col">
            <div class="resource_title_wrapper flex-col">
              <span class="resource_title">学习资源</span>
            </div>
            <div class="resource_list flex-col justify-between">
              <div
                class="resource_item flex-row"
                :style="
                  (index + 1) % 2 === 1
                    ? 'background-color: rgba(247, 251, 255, 1);'
                    : ''
                "
                v-for="(resource, index) in resources"
                :key="index"
                @click="downloadResource(resource)"
              >
                <span class="resource_name">{{ resource.resource_name }}</span>
                <img
                  class="resource_icon"
                  referrerpolicy="no-referrer"
                  :src="
                    resource.resource_type === 0
                      ? require('../../assets/student/course/FigmaDDSSlicePNGfe50c5b5f8e0daad55289961d91b4ad7.png')
                      : require('../../assets/student/course/FigmaDDSSlicePNG44c853edbb46cf5e4033f2a0dc21d779.png')
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import alovaInstance from "@/utils/alova"
import StudentHeader from "@/components/StudentHeader.vue"
const router = useRouter()
const route = useRoute()

const title = ref("课程")
const info = ref({
  courseName: "",
  progress: "0%",
  tasknum: 0,
  hardnum: 0,
  taskCount: 1,
  complete: 0,
})
const tasks = ref([])
const lists = ref([])
const targets = ref([])
const resources = ref([])

// 拖动相关状态
const taskListContainer = ref(null)
const isDragging = ref(false)
const startX = ref(0)
const scrollLeft = ref(0)
const dragThreshold = 3 // 降低拖动阈值，减少延迟
const hasMoved = ref(false)
const isClick = ref(true)

// 新增：获取课程信息的方法
const fetchCourseInfo = async () => {
  try {
    const lessonId = route.query.courseId
    const response = await alovaInstance.Post(
      "/Task/GetTaskNavigatorViewList",
      {
        lessonId: lessonId,
      }
    )
    if (response.code === 1000) {
      lists.value = []
      tasks.value = []
      resources.value = []
      for (let i = 0; i < response.data.taskNavigatorInfos.length; i++) {
        tasks.value.push(response.data.taskNavigatorInfos[i])
        if (response.data.taskNavigatorInfos[i].taskType == 0) {
          lists.value.push(response.data.taskNavigatorInfos[i])
        }
        if (response.data.taskNavigatorInfos[i].completedStatu == 1) {
          info.value.complete += 1
        }
      }
      info.value.taskCount = response.data.taskNavigatorInfos.length
      info.value.tasknum = lists.value.length
      info.value.hardnum = info.value.taskCount - lists.value.length
      info.value.progress =
        ((info.value.complete / info.value.taskCount) * 100).toFixed(0) + "%"

      targets.value = []
      for (let i = 0; i < response.data.lessonTargetList.length; i++) {
        targets.value.push(response.data.lessonTargetList[i].target)
      }

      resources.value = response.data.lessonResourceList
    } else {
      alert("获取课程信息失败：" + response.message)
    }
  } catch (error) {
    console.error("获取课程数据失败:", error)
    alert("加载课程信息失败，请稍后重试")
  }
}

// 组件挂载后自动获取数据
onMounted(() => {
  title.value = localStorage.getItem("title")
  info.value.courseName = route.query.courseName
  fetchCourseInfo()
})

// 优化的拖动方法 - 减少延迟
const handleMouseDown = (e) => {
  if (!taskListContainer.value) return

  // 立即设置状态，减少感知延迟
  isDragging.value = false  // 初始设为false，在move中确认
  isClick.value = true
  hasMoved.value = false

  const rect = taskListContainer.value.getBoundingClientRect()
  startX.value = e.clientX
  scrollLeft.value = taskListContainer.value.scrollLeft

  // 使用passive: false提高响应性
  taskListContainer.value.style.cursor = 'grabbing'
  taskListContainer.value.style.userSelect = 'none'

  // 添加全局事件监听，解决鼠标移出容器问题
  document.addEventListener('mousemove', handleGlobalMouseMove, { passive: false })
  document.addEventListener('mouseup', handleGlobalMouseUp, { passive: false })

  e.preventDefault()
}

const handleGlobalMouseMove = (e) => {
  if (!taskListContainer.value) return

  const x = e.clientX
  const walk = (startX.value - x) * 1.5  // 直接计算差值

  // 立即应用滚动，减少延迟
  taskListContainer.value.scrollLeft = scrollLeft.value + walk

  // 快速判断是否为拖动
  if (Math.abs(x - startX.value) > dragThreshold) {
    isClick.value = false
    hasMoved.value = true
  }

  e.preventDefault()
}

const handleGlobalMouseUp = (e) => {
  if (!taskListContainer.value) return

  // 清理全局事件监听
  document.removeEventListener('mousemove', handleGlobalMouseMove)
  document.removeEventListener('mouseup', handleGlobalMouseUp)

  taskListContainer.value.style.cursor = 'grab'
  taskListContainer.value.style.userSelect = ''

  // 立即重置状态，无需延迟
  isDragging.value = false
}

// 优化的触摸事件 - 减少延迟
const handleTouchStart = (e) => {
  if (!taskListContainer.value || e.touches.length !== 1) return

  isClick.value = true
  hasMoved.value = false

  const touch = e.touches[0]
  startX.value = touch.clientX
  scrollLeft.value = taskListContainer.value.scrollLeft

  // 添加全局触摸事件
  document.addEventListener('touchmove', handleGlobalTouchMove, { passive: false })
  document.addEventListener('touchend', handleGlobalTouchEnd, { passive: false })

  e.preventDefault()
}

const handleGlobalTouchMove = (e) => {
  if (!taskListContainer.value || e.touches.length !== 1) return

  const touch = e.touches[0]
  const walk = (startX.value - touch.clientX) * 1.5

  // 立即滚动
  taskListContainer.value.scrollLeft = scrollLeft.value + walk

  if (Math.abs(touch.clientX - startX.value) > dragThreshold) {
    isClick.value = false
    hasMoved.value = true
  }

  e.preventDefault()
}

const handleGlobalTouchEnd = (e) => {
  if (!taskListContainer.value) return

  // 清理全局触摸事件
  document.removeEventListener('touchmove', handleGlobalTouchMove)
  document.removeEventListener('touchend', handleGlobalTouchEnd)

  // 立即重置状态
  isDragging.value = false
}

// 超快速点击处理 - 无延迟判断
const handleTaskClick = (item, event) => {
  // 立即判断，无延迟
  if (!isClick.value || hasMoved.value) {
    event.preventDefault()
    event.stopPropagation()
    return
  }

  toCourseTask(item)
}

// 清理事件监听器
onUnmounted(() => {
  // 清理可能存在的全局事件监听器
  document.removeEventListener('mousemove', handleGlobalMouseMove)
  document.removeEventListener('mouseup', handleGlobalMouseUp)
  document.removeEventListener('touchmove', handleGlobalTouchMove)
  document.removeEventListener('touchend', handleGlobalTouchEnd)
})

const selectedType = ref(0)
const resetList = (type) => {
  selectedType.value = type
  lists.value = []
  for (let i = 0; i < tasks.value.length; i++) {
    if (tasks.value[i].taskType == type) {
      lists.value.push(tasks.value[i])
    }
  }
}

const toCourseTask = (item) => {
  localStorage.setItem("tasklists", JSON.stringify(tasks.value))
  if (item.resultType == "python") {
    router.push({
      name: "CourseTask",
      query: {
        taskId: item.taskId,
      },
    })
    return
  } else if (item.resultType == "scratchbit") {
    router.push({
      name: "Microbit",
      query: {
        taskId: item.taskId,
      },
    })
    return
  } else if (item.resultType == "hex") {
    // 判断是否第一次进入
    const hasVisited = localStorage.getItem(item.taskId + "_fv")
    if (hasVisited) {
      router.push({
        name: "Microbit",
        query: {
          taskId: item.taskId,
        },
      })
    } else {
      // 第一次进入，设置标记
      localStorage.setItem(item.taskId + "_fv", "true")
      router.push({
        name: "Microbit",
        query: {
          // hex: item.hexUrl,
          hex: "https://yzm-images.oss-cn-beijing.aliyuncs.com/aifile/hex/p" + item.taskId + ".hex"
        },
      })
    }
    return
  }
  router.push({
    name: "ScratchTask",
    query: {
      taskId: item.taskId,
    },
  })
}

const downloadResource = (resource) => {
  window.open(resource.url, "_blank")
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 53.25vw;
  overflow: hidden;
}

.main_container {
  width: 100vw;
  height: 52.45vw;
  margin-bottom: 0.06vw;
}

.content_section {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 32px;
  position: relative;
  width: 75vw;
  height: 47.35vw;
  margin: 1.35vw 0 0 12.5vw;
}

.header_section {
  background-color: rgba(128, 174, 243, 1);
  border-radius: 32px 32px 0px 0px;
  width: 75vw;
  height: 2.87vw;
}

.course_title {
  width: 100%;
  height: 2.19vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.5vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.5vw 0 0 0;
}

.completion_text {
  width: 6.93vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.9vw 0 0 -17.03vw;
}

.progress_text {
  width: 2.82vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.9vw 1.19vw 0 0.31vw;
}

.task_section {
  background-color: rgba(104, 162, 250, 0.06);
  height: 22.87vw;
  width: 75vw;
  position: relative;
}

.task_filter_group {
  width: 15.53vw;
  height: 2.3vw;
  margin: 1.66vw 0 0 3.54vw;
}

.normal_task_button {
  background-color: rgba(55, 91, 165, 1);
  border-radius: 8px;
  width: 7.14vw;
  height: 2.3vw;
  cursor: pointer;
}

.task_icon {
  width: 1.25vw;
  height: 1.31vw;
  margin: 0.52vw 0 0 1.04vw;
}

.task_label {
  width: 3.55vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.57vw 0.98vw 0 0.31vw;
}

.text_selected {
  color: rgba(247, 251, 255, 1);
}

.challenge_task_button {
  background-color: rgba(234, 238, 242, 1);
  border-radius: 8px;
  width: 8.5vw;
  height: 2.3vw;
  cursor: pointer;
  margin-left: 0.6vw;
}

.challenge_icon {
  width: 1.25vw;
  height: 1.31vw;
  margin: 0.52vw 0 0 1.04vw;
}

.challenge_label {
  width: 3.55vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.57vw 0.98vw 0 0.31vw;
  cursor: pointer;
}

.task_list_container {
  width: 69vw;
  height: 16.06vw;
  margin: 1.3vw 0 0 2.15vw;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  cursor: grab;
  -webkit-overflow-scrolling: touch;
  justify-content: flex-start;
  scroll-behavior: auto; /* 改为auto减少滚动延迟 */
  position: relative;
  touch-action: pan-x; /* 启用浏览器优化 */
  will-change: scroll-position; /* 启用硬件加速 */
}

.task_list_container:active {
  cursor: grabbing;
}

.task_list_container::-webkit-scrollbar {
  display: none;
}

.task_list_container::-webkit-scrollbar {
  display: none;
}

.task_card {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 22px;
  width: 18.44vw;
  height: 15.06vw;
  margin-left: 1.5vw;
}

.task_header {
  width: 15.94vw;
  height: 2.09vw;
  margin: 0.78vw 0 0 1.66vw;
}

.task_serial {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.16vw;
}

.completion_icon {
  width: 2.09vw;
  height: 2.09vw;
}

.task_image {
  width: 15.11vw;
  height: 10.16vw;
  margin: 0.05vw 0 0 1.66vw;
}

.task_name {
  width: 100%;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0 0 0.72vw 0;
}

.pagination_container {
  width: 100%;
  height: 0.53vw;
  margin: 0.1vw 0 0 0;
}

.pagination_dot {
  width: 3.65vw;
  height: 0.53vw;
  margin-left: 0.8vw;
}

.learning_target_header {
  width: 53.91vw;
  height: 2.09vw;
  margin: 1.97vw 0 0 4.06vw;
}

.target_title_group {
  width: 7.24vw;
  height: 1.67vw;
  margin-top: 0.37vw;
}

.target_icon {
  width: 1.67vw;
  height: 1.67vw;
}

.target_title {
  width: 5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  line-height: 1.8vw;
}

.resource_title_wrapper {
  background-color: rgba(55, 91, 165, 1);
  border-radius: 24px;
  height: 2.09vw;
  margin-left: 1.3vw;
  margin-top: 1vw;
  width: 6.52vw;
}

.resource_title {
  width: 6.52vw;
  height: 2.09vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 2.09vw;
}

.learning_content {
  width: 69.43vw;
  height: 5.94vw;
  margin: 0.88vw 0 9.73vw 4.06vw;
}

.target_list {
  width: 31.15vw;
  height: 5.42vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  margin-top: 0.53vw;
}

.resource_list {
  width: 30.84vw;
  height: 5.63vw;
  margin-top: 1vw;
}

.resource_item {
  cursor: pointer;
  width: 30.7vw;
  height: 2.82vw;
}

.resource_name {
  width: 7.3vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.72vw 0 0 2.39vw;
}

.resource_icon {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.36vw 1.56vw 0 17.5vw;
}

.resource_section {
  border-radius: 16px;
  position: absolute;
  left: 42.66vw;
  top: 27.92vw;
  width: 30.84vw;
  height: 17.71vw;
  border: 1px solid rgba(104, 162, 250, 0.6);
}

.normal_task_button {
  background-color: rgba(234, 238, 242, 1);
  cursor: pointer;
}

.normal_task_button.selected {
  background-color: rgba(55, 91, 165, 1);
}

.challenge_task_button {
  background-color: rgba(234, 238, 242, 1);
  cursor: pointer;
}

.challenge_task_button.selected {
  background-color: rgba(55, 91, 165, 1);
}

.normal_task_button.selected .task_label {
  color: rgba(255, 255, 255, 1);
}

.challenge_task_button.selected .challenge_label {
  color: rgba(255, 255, 255, 1);
}

.progress_bar_container {
  width: 4.28vw;
  height: 1.25vw;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  margin: 0.75vw 0 0 0.5vw;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(#f3ab45 0%, #ffd75c 100%);
  transition: width 0.3s ease;
}

.user_select_none {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>
